import { render, staticRenderFns } from "./PackageTransferReceiptPrint.vue?vue&type=template&id=0a1761bb&scoped=true&"
import script from "./PackageTransferReceiptPrint.vue?vue&type=script&lang=js&"
export * from "./PackageTransferReceiptPrint.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=0a1761bb&scoped=true&lang=css&"
import style1 from "./PackageTransferReceiptPrint.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1761bb",
  null
  
)

export default component.exports